import type { ButtonHTMLAttributes } from "react";
import { typography } from "../Typography/styles";
import { cn } from "packages/dsaui/src/utils";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  block?: boolean;
}

export const Button = ({
  block = false,
  className,
  disabled = false,
  onClick,
  type = "button",
  ...props
}: ButtonProps) => (
  <button
    className={cn(
      typography.buttonPrimaryLabel.className,
      "appearance-none items-center justify-center rounded-md border-0 px-4 py-2.5 text-center shadow-sm transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed",
      "bg-dsa-red hover:bg-dsa-dark-red focus-visible:ring-dsa-red disabled:bg-red-300 disabled:text-white",
      block ? "flex w-full" : "inline-flex",
      className,
    )}
    disabled={disabled}
    onClick={onClick}
    type={type}
    {...props}
  />
);

export default Button;
